import React, { useEffect, useState } from "react";
import { Input } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import Back from "../../../Components/Back";
import SimpleBackdrop from "../../../Components/SimpleBackDrop";
import { useCommonUserProvider } from "../../../Providers/Common/User";
import { useNavigate } from "react-router-dom";
import UserProfileAvatar from "../../../Components/UserProfileAvatar";

export default function UserProfile() {
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const { changePassword, getUserProfile, updateUserProfile, loading } = useCommonUserProvider();
  const [updateCount, setUpdateCount] = useState(1);
  useEffect(() => {}, [user]);

  useEffect(() => {
    (async () => {
      const userDetails = await getUserProfile();
      setUser(userDetails);
    })();
  }, [updateCount]);

  

  const sendUpdatePasswordEmail = (e) => {
    changePassword()
      .then((res) => {
        if (res) {
          Swal.fire("", "Email send successfully", "success");
        } else {
          Swal.fire("", "Something went wrong", "info");
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire("Oops", "Something went wrong", "error");
      });
  };
  const onInputChange = (e, name) => {
    setUser({
      ...user,
      [name]: e.target.value,
    });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    updateUserProfile(user);
  };
  return (
    <div className="bg-white p-4 mx-auto rounded-md shadow-md my-8">
      <SimpleBackdrop open={loading} />
      <div className="">
        <span className="text-2xl" style={{ color: "#139588" }}>
          <Back onClick={() => navigate(-1)} />
          Edit Profile
        </span>
        <hr className="mt-8" />
      </div>
      <UserProfileAvatar user={user} setUpdateCount={setUpdateCount} updateCount={updateCount}/>
      <hr className="mt-8" />
      <h1 className="text-base font-semibold text-[#2EBAA3] pt-5">
        Personal Details
      </h1>
      <form onSubmit={onSubmit}>
        <div className="flex lg:flex-row flex-col lg:space-x-16">
          <div>
            <div className="flex flex-col">
              <span className="my-2 text-gray-700">ProLegion ID</span>
              <Input
                value={user?.username}
                readOnly
                className="w-80 border-none -ml-2"
              />
            </div>
            <div className="flex flex-col">
              <span
                className="my-2 text-gray-700"
              >
                First Name
              </span>
              <Input value={user?.firstName} onChange={(e) => onInputChange(e, "firstName")} type="text" placeholder="First Name" />
            </div>
            <div className="flex flex-col">
              <span className="my-2 text-gray-700">Company Name</span>
              <Input
                readOnly
                value={user?.company}
                className="w-80 border-none -ml-2"
              />
            </div>
          </div>
          <div>
            <div className="flex flex-col">
              <span className="my-2 text-gray-700">Email ID</span>
              <Input
                readOnly
                className="w-80 border-none -ml-2"
                value={user?.email}
              />
            </div>
            <div className="flex flex-col">
              <span className="my-2 text-gray-700">Last Name</span>
              <Input
                type="text"
                placeholder="Last Name"
                value={user?.lastName}
                onChange={(e) => onInputChange(e, "lastName")}
              />
            </div>
            <div className="flex flex-col">
              <span className="my-2 text-gray-700">Contact Number</span>
              <Input
                maxLength={13}
                type="tel"
                value={user?.phone}
                onChange={(e) => onInputChange(e, "phone")}
                placeholder={"Enter Contact Number"}
              />
            </div>
          </div>
        </div>
        <div className="flex lg:flex-row flex-col lg:space-x-16 pt-3">
          <div>
            <div className="flex flex-col">
              <span className="my-2 text-gray-700">Change Password</span>
              <button
                className="sm:mt-0 mt-4 text-sm space-x-8 px-2"
                type="submit"
                style={{
                  height: "35px",
                  background: "#139588",
                  borderRadius: "5px",
                  color: "white",
                }}
                onClick={sendUpdatePasswordEmail}
              >
                Get link by email
              </button>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <div className="mt-2">
            <div className="flex flex-col">
              <span className=" text-gray-700 my-2">Website</span>
              <Input
                placeholder={"Enter Link"}
                value={user?.website}
                onChange={(e) => onInputChange(e, "website")}
              />
            </div>
            <div className="flex flex-col">
              <span className=" text-gray-700 my-2">LinkedIn</span>
              <Input
                placeholder={"Enter Link"}
                value={user?.linkedin}
                onChange={(e) => onInputChange(e, "linkedin")}
              />
            </div>
            <div className=" text-gray-700 mt-2">Bio</div>
            <textarea
              className="border-[1px] border-[#C6C6C6] mt-4 border-solid"
              placeholder={"Enter Text"}
              value={user?.about}
              onChange={(e) => onInputChange(e, "about")}
              style={{
                borderRadius: "4px",
                width: "100%",
                height: "154px",
                paddingLeft: "10px",
              }}
            />
          </div>
        </div>
        <div className="flex flex-row justify-end mt-4 space-x-4">
          <button
            className="sm:mt-0 mt-4 text-sm space-x-8 px-2"
            style={{
              height: "35px",
              background: "white",
              borderRadius: "5px",
              border: " 0.5px solid #000000",
            }}
          >
            Discard Changes
          </button>
          <button
            className="sm:mt-0 mt-4 text-sm space-x-8 px-2"
            type="submit"
            style={{
              height: "35px",
              background: "#139588",
              borderRadius: "5px",
              color: "white",
            }}
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
}
